import styled from 'styled-components';

export const CatalogPage = styled.div`
  max-width: 960px;
  padding-bottom: 32px;
`;

export const CatalogIntro = styled.div`
  margin-bottom: 20px;
  h5 {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.4px;
    line-height: 32px;
    margin: 0 0 8px 0;
  }
  p {
    font-size: 14px;
    color: rgba(30, 41, 51, 0.75);
    line-height: 1.6;
    margin: 0;
  }
`;

export const CatalogCard = styled.div`
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: rgb(0 0 0 / 3%) 0px 2px 5px;
  border-left: 4px solid ${props => props.accent || '#6b8dd6'};
`;

export const CatalogCardHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px 12px;
  border-bottom: 1px solid rgb(239, 241, 244);
`;

export const CatalogCardTitleBlock = styled.div`
  h6 {
    margin: 0 0 6px 0;
    font-size: 15px;
    font-weight: 600;
    color: rgb(40, 42, 48);
  }
  p {
    margin: 0;
    font-size: 13px;
    color: rgba(30, 41, 51, 0.65);
    line-height: 1.5;
  }
`;

export const CountBadge = styled.span`
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 16px;
  background: rgb(248, 249, 251);
  border: 1px solid rgb(223, 225, 228);
  color: rgb(60, 65, 73);
`;

export const CatalogRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  border-bottom: 1px solid rgb(239, 241, 244);
  font-size: 14px;
  &:last-child {
    border-bottom: none;
  }
`;

export const RowIndex = styled.span`
  min-width: 22px;
  color: rgba(30, 41, 51, 0.45);
  font-size: 13px;
  font-weight: 600;
`;

export const RowMain = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  align-items: baseline;
`;

export const RowValue = styled.span`
  font-weight: 600;
  color: rgb(40, 42, 48);
`;

export const RowLabel = styled.span`
  color: rgba(30, 41, 51, 0.65);
  font-size: 13px;
`;

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const AddRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: flex-end;
  padding: 14px 18px;
  background: rgb(248, 249, 251);
  border-top: 1px solid rgb(239, 241, 244);
`;

export const AddField = styled.div`
  flex: 1 1 160px;
  min-width: 120px;
  label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: rgb(60, 65, 73);
    margin-bottom: 4px;
  }
`;
